import Base from './base'

export default class Dashboard extends Base {
  listDashboards(params?: object) {
    return this.apiClient.get('dashboards', params)
  }

  createDashboard(data: object) {
    return this.apiClient.post('dashboards', data)
  }

  deleteDashboard(id: string) {
    return this.apiClient.delete(`dashboards/${id}`)
  }

  updateDashboard(id: string, data: object) {
    return this.apiClient.put(`dashboards/${id}`, data)
  }

  getDashboardMetrics() {
    return this.apiClient.get('clients/dashboard-metrics')
  }

  // ── Home dashboard (`/dashboard/*`) ────────────────────────────────────────
  // Scoped to the invoking user, so these take no id. Distinct from the saved
  // "dashboards" CRUD above.

  listAgenda(params: object = {}) {
    return this.apiClient.get('dashboard/agenda', params)
  }

  listMyWork() {
    return this.apiClient.get('dashboard/my-work')
  }

  listMyClientsHealth(params: object = {}) {
    return this.apiClient.get('dashboard/my-clients-health', params)
  }

  listMyDiligence(params: object = {}) {
    return this.apiClient.get('dashboard/my-diligence', params)
  }

  getBriefing() {
    return this.apiClient.get('dashboard/briefing')
  }

  refreshBriefing() {
    return this.apiClient.post('dashboard/briefing/refresh', {})
  }

  /** `index` is the bullet's position in the stored brief, `generatedAt` the brief's own. */
  setBriefingBulletCompleted(index: number, data: { completed: boolean; generatedAt: string }) {
    return this.apiClient.put(`dashboard/briefing/bullets/${index}`, data)
  }

  /**
   * The meeting's one shared brief, found from the Google event id the calendar holds. A brief
   * still generating comes back with `status: generating`; callers poll.
   */
  getMeetingBrief(googleEventId: string) {
    return this.apiClient.get(`meetings/brief/${encodeURIComponent(googleEventId)}`)
  }

  regenerateMeetingBrief(meetingId: string) {
    return this.apiClient.post(`meetings/${meetingId}/brief/regenerate`, {})
  }

  listDealCleanupSuggestions(params: object = {}) {
    return this.apiClient.get('dashboard/deal-cleanup', params)
  }

  respondToDealCleanupSuggestion(id: string, data: object) {
    return this.apiClient.post(`dashboard/deal-cleanup/${id}/respond`, data)
  }
}
